import { render } from "./apply-job.vue?vue&type=template&id=213c29f0"
import script from "./apply-job.vue?vue&type=script&lang=js"
export * from "./apply-job.vue?vue&type=script&lang=js"
script.render = render

export default script